import {defineStore} from "pinia";
import {reactive, ref} from "vue";

/** Zustand der Recherche-Mail-Liste, bleibt beim Wechsel zu den Details und zurück erhalten. */
export const useRegistrationInquiryStore = defineStore("registrationInquiry", () => {
  /** Status-Filter der Liste ("open" = offene) */
  const statusFilter = ref("open");
  /** Seitengröße und aktuelle Seite des Grids */
  const listPageSettings = reactive({pageSize: 25, currentPage: 1});
  /** Zuletzt markierte Anfrage: beim Zurückkehren wieder markieren */
  const selectedId = ref<string | undefined>(undefined);

  return {statusFilter, listPageSettings, selectedId};
});
